import { SxStyles } from '../../../../../types';
import theme from '../../../../../theme';
import { getResponsiveSize } from '../../../../../utils';

export const UploadStyle: SxStyles = {
  uploadContainer: {
    width: '100%',
    padding: 0,
    margin: 0,
    position: 'relative',

    '& .top-container': {
      display: 'flex',
      justifyContent: 'center',
      paddingTop: getResponsiveSize(30),
      paddingBottom: getResponsiveSize(30),
      borderBottom: `1px solid ${theme.palette.neutral?.grey8}`,
      position: 'relative',

      '& .tabs-group': {
        minHeight: 'unset',
        display: 'flex',
        alignSelf: 'flex-start',
        position: 'absolute',
        top: '70%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        '& .MuiTabs-scroller': {
          height: getResponsiveSize(50),
          '& MuiTabs-flexContainer': {
            marginBottom: '10px',
            padding: 0,
            minHeight: 0,
            height: 0,
          },

          '& .MuiTab-root': {
            textTransform: 'capitalize',
            color: '#588595',
            fontFamily: theme.typography.mainFontFamily,
            fontSize: getResponsiveSize(17),
            minHeight: 0,
            minWidth: 0,
            padding: 0,
            fontWeight: '400',
            mr: getResponsiveSize(33),
          },
          '& .Mui-selected': {
            color: '#2392BA',
            fontWeight: '700',
            fontFamily: theme.typography.mainFontFamily,
          },
          '& .MuiTabs-indicator': {
            backgroundColor: '#2392BA',
            bottom: '40%',
            borderRadius: getResponsiveSize(5),
            height: getResponsiveSize(3),
          },
        },
      },
    },
    '& .content-container': {
      p: getResponsiveSize(25),
      pt: getResponsiveSize(20),
      mr: getResponsiveSize(10),
      height: 'auto',
      maxHeight: getResponsiveSize(350),
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      overflow: 'scroll',
      overflowX: 'hidden',
      '&::-webkit-scrollbar': {
        width: 4,
      },
      '&::-webkit-scrollbar-track': {
        webkitBorderRadius: '100px',
        borderRadius: '100px',
        m: getResponsiveSize(10),
      },
      '&::-webkit-scrollbar-thumb': {
        webkitBorderRadius: '100px',
        borderRadius: '100px',
        background: theme.palette.neutral?.grey8,
      },
    },
  },
};
